import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  BRAND_CREATE,
  BRAND_EDIT,
  BRAND_VIEW,
  GROUP_CREATE,
  GROUP_EDIT,
  GROUP_VIEW,
  HOTEL_CREATE,
  HOTEL_EDIT,
  HOTEL_VIEW,
  PROPERTY_TYPE_BRANDS,
  PROPERTY_TYPE_GROUPS,
  PROPERTY_TYPE_HOTELS,
} from '../../constants/PropertyConst';
import {
  RBAC_PERMISSION_LEVEL_NO_ACCESS,
  RBAC_TYPE_BRANDS,
  RBAC_TYPE_GROUPS,
  RBAC_TYPE_HOTELS,
} from '../../constants/RoleConsts';
import { validateUserSession } from '../../utils/authUtils';
import BrandCreate from './brand/brand-create/Brand-Create';
import BrandList from './brand/brand-list/Brand-List';
import BrandView from './brand/brand-view/Brand-View';
import GroupCreate from './group/group-create/Group-Create';
import GroupList from './group/group-list/Group-List';
import GroupView from './group/group-view/Group-View';
import HotelCreate from './hotel/hotel-create/Hotel-Create';
import HotelList from './hotel/hotel-list/Hotel-List';
import HotelView from './hotel/hotel-view/Hotel-View';
import { allGroupsSelector, selectedHotelSelector } from './propertySlice';
import { checkAuthState } from '../../utils/APIUtils';
import { getCustomRoleControl } from '../../utils/RBACUtil';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    minWidth: '170px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    minWidth: '170px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const Properties = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const originalGroups = useSelector(allGroupsSelector);

  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(
    permissions[RBAC_TYPE_GROUPS] !== 0
      ? PROPERTY_TYPE_GROUPS
      : permissions[RBAC_TYPE_BRANDS] !== 0
      ? PROPERTY_TYPE_BRANDS
      : PROPERTY_TYPE_HOTELS,
  ); // 'BRANDS' | 'HOTELS'
  const [state, setState] = useState({ type: GROUP_CREATE, status: false });
  const [viewState, setViewState] = useState({
    type: '',
    status: false,
    obj: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isPropertyAdmin, setIsPropertyAdmin] = useState(false);
  const history = useHistory();
  useEffect(() => {
    if (activeTab === 'BRANDS' || activeTab === 'GROUPS' || activeTab === 'HOTELS') {
      setPage(0);
      setRowsPerPage(5);
    }
  }, [activeTab]);

  useEffect(() => {
    (async () => {
      const currUser = await checkAuthState();
      const customRole = await getCustomRoleControl();
      if (
        currUser &&
        currUser?.attributes &&
        (currUser?.attributes['custom:role'] === 'PROPERTY_ADMIN' ||
          currUser?.attributes['custom:role'] === 'HOTEL_ADMIN')
      ) {
        setIsPropertyAdmin(true);
      } else {
        const isPropertyRoleInclude = customRole?.includes('HOTEL_ADMIN' || 'PROPERTY_ADMIN');
        if (isPropertyRoleInclude) {
          setIsPropertyAdmin(true);
        }
      }
    })();
  }, []);

  useEffect(() => {
    validateUserSession(history);
  }, [activeTab, history]);

  useEffect(() => {
    if (selectedHotel && viewState.status) {
      setViewState({
        type: '',
        status: false,
        obj: null,
      });
    }
  }, [selectedHotel]);

  useEffect(() => {
    if (selectedHotel && viewState.status) {
      setActiveTab(
        permissions[RBAC_TYPE_GROUPS] !== 0
          ? PROPERTY_TYPE_GROUPS
          : permissions[RBAC_TYPE_BRANDS] !== 0
          ? PROPERTY_TYPE_BRANDS
          : PROPERTY_TYPE_HOTELS,
      );
    }
  }, [selectedHotel]);

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    validateUserSession(history);
    setState(open);
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case GROUP_CREATE:
        return <GroupCreate toggleDrawer={onDrawerToggle} showLoader={showLoader}></GroupCreate>;
      case GROUP_EDIT:
        return (
          <GroupCreate
            toggleDrawer={onDrawerToggle}
            showLoader={showLoader}
            group={state.obj}
          ></GroupCreate>
        );
      case BRAND_CREATE:
        return <BrandCreate toggleDrawer={onDrawerToggle} showLoader={showLoader}></BrandCreate>;
      case BRAND_EDIT:
        return (
          <BrandCreate
            toggleDrawer={onDrawerToggle}
            brand={state.obj}
            showLoader={showLoader}
          ></BrandCreate>
        );
      case HOTEL_CREATE:
        return <HotelCreate toggleDrawer={onDrawerToggle} showLoader={showLoader}></HotelCreate>;
      case HOTEL_EDIT:
        return (
          <HotelCreate
            toggleDrawer={onDrawerToggle}
            showLoader={showLoader}
            hotel={state.obj}
          ></HotelCreate>
        );
      default:
        break;
    }
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case GROUP_VIEW:
        return (
          <GroupView
            toggleDrawer={onDrawerToggle}
            onViewToggle={onViewToggle}
            group={inpState.obj}
            permissions={permissions}
          ></GroupView>
        );
      case BRAND_VIEW:
        return (
          <BrandView
            toggleDrawer={onDrawerToggle}
            onViewToggle={onViewToggle}
            brand={inpState.obj}
            permissions={permissions}
          ></BrandView>
        );
      case HOTEL_VIEW:
        return (
          <HotelView
            toggleDrawer={onDrawerToggle}
            onViewToggle={onViewToggle}
            hotel={inpState.obj}
            permissions={permissions}
          ></HotelView>
        );
      default:
        break;
    }
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState.status && <>{switchViewContent(viewState)}</>}
      {!viewState.status && (
        <div className='container pt-4'>
          <div className='row d-flex'>
            <div className='col-md-6'>
              <span className='page-title'>Properties</span>
            </div>
          </div>
          <div className='row d-flex pt-4'>
            <div className='d-flex gap-3'>
              {permissions[RBAC_TYPE_GROUPS] !== RBAC_PERMISSION_LEVEL_NO_ACCESS && (
                <Button
                  size='large'
                  variant={activeTab === 'GROUPS' ? 'outlined' : 'text'}
                  className={activeTab === 'GROUPS' ? classes.activeButton : classes.button}
                  onClick={() => setActiveTab('GROUPS')}
                >
                  {originalGroups?.length > 1 ? 'Groups' : 'Group'}
                </Button>
              )}
              {permissions[RBAC_TYPE_BRANDS] !== RBAC_PERMISSION_LEVEL_NO_ACCESS && (
                <Button
                  size='large'
                  variant={activeTab === 'BRANDS' ? 'outlined' : 'text'}
                  className={activeTab === 'BRANDS' ? classes.activeButton : classes.button}
                  onClick={() => setActiveTab('BRANDS')}
                >
                  Brands
                </Button>
              )}
              {permissions[RBAC_TYPE_HOTELS] !== RBAC_PERMISSION_LEVEL_NO_ACCESS && (
                <Button
                  size='large'
                  variant={activeTab === 'HOTELS' ? 'outlined' : 'text'}
                  className={activeTab === 'HOTELS' ? classes.activeButton : classes.button}
                  onClick={() => setActiveTab('HOTELS')}
                >
                  Hotels
                </Button>
              )}
            </div>
          </div>
          <div className='row p-2 d-flex pt-4'>
            <div className='card shadow'>
              {activeTab === 'GROUPS' && (
                <GroupList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                  isPropertyAdmin={isPropertyAdmin}
                />
              )}
              {activeTab === 'BRANDS' && (
                <BrandList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                  isPropertyAdmin={isPropertyAdmin}
                />
              )}
              {activeTab === 'HOTELS' && (
                <HotelList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  permissions={permissions}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                  isPropertyAdmin={isPropertyAdmin}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Properties;
